import { gql } from 'src/generated/gql';

export const GET_MY_DAY_TODAY_VISITS_QUERY = gql(`
  query Staff_GetMyDayTodayVisits($providerId: ID!) {
    staff_getAcceptNextPatientSection(providerId: $providerId) {
      status
      acceptMode
      nextAvailability
      scheduleItem {
        type
        start
        eventId
        patient {
          id
          firstName
          lastName
          preferredName
        }
      }
    }
    staff_getProviderUnsignedVisits(providerId: $providerId) {
      id
      start
      attendeesDisplay {
        firstName
        lastName
        preferredName
        userType
      }
    }
  }
`);
